export const iconFontAwesomeCampingToiletPaper = (
	<i className="fa-solid fa-toilet-paper"></i>
);
